/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../util/headers"

export const getTenDwcCalculator = (baseUrl, id) => {
  const path = `${baseUrl}/calculators/details`
  return axios.get(path, { params: { id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getPulseCheck = (baseUrl, id) => {
  const path = `${baseUrl}/calculators/pulse_check_details`
  return axios.get(path, { params: { id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getMentalSkills = (baseUrl, id) => {
  const path = `${baseUrl}/calculators/mental_skills_details`
  return axios.get(path, { params: { id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getBurnoutProof = (baseUrl, id) => {
  const path = `${baseUrl}/calculators/burnout_proof_details`
  return axios.get(path, { params: { id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getCalculatorQuestions = (baseUrl, params) => {
  const path = `${baseUrl}/calculators/`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getMatchfitSimple = (baseUrl, params) => {
  const path = `${baseUrl}/calculators/get_matchfit_simple`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}